import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';

// Configuración del QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache por 5 minutos
      staleTime: 5 * 60 * 1000,
      // Mantener datos por 10 minutos
      cacheTime: 10 * 60 * 1000,
      // Reintentar 1 vez en caso de error
      retry: 1,
      // No refetch en focus window (puede ser molesto en desarrollo)
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Reintentar 1 vez las mutaciones fallidas
      retry: 1,
    },
  },
});

interface QueryProviderProps {
  children: ReactNode;
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

// Exportar el queryClient para uso directo si es necesario
export { queryClient };

export default QueryProvider;
